import { c as _c } from "react/compiler-runtime";
import { DesktopNavigation, NavigationData as DesktopNavigationData } from '@spa/components/nav/desktop-navigation.component';
import { NavigationData as MobileNavigationData, MobileNavigationItem, MobileNavigationItemWithIcon } from '@spa/components/nav/navigation.types';
import { ReactElement, useMemo, useState } from 'react';
import { CmsVisibility } from '@spa/lib/store/settings/CmsVisibility';
import ConfigurableCmsSlotMetadata from '../../top-level-components/cms-page/metadata/configurable/configurable-cms-slot-metadata.component';
import { Metadata } from '@spa/pages-converters/cms/component-envelops/CmsComponentEnvelopBase';
import { MobileNavigation } from './mobile-navigation.component';
import classNames from 'clsx';
import selectGeneralSettings from '@spa/lib/store/settings/selectors/selectGeneralSettings';
import styles from './nav.component.module.scss';
import { useSelector } from 'react-redux';
export type NavigationData = (DesktopNavigationData & MobileNavigationData) | null;
interface Props {
  readonly id: string;
  readonly isNavMobileActive: boolean;
  readonly onClick: () => void;
  readonly metadata: Metadata[];
  readonly editorMode: boolean;
  readonly onSidebarVisibilityChange: (open: boolean) => void;
  readonly navigation: NavigationData | null;
  readonly iconNavigationItem: ReadonlyArray<MobileNavigationItemWithIcon>;
  readonly metaNavigationItem: ReadonlyArray<MobileNavigationItem>;
  readonly quickNavigationItems: ReadonlyArray<MobileNavigationItemWithIcon>;
  readonly reducedView: boolean;
}
export default function NavComponent(t0) {
  const $ = _c(34);
  const {
    id,
    isNavMobileActive,
    onSidebarVisibilityChange,
    metadata,
    editorMode,
    navigation,
    iconNavigationItem,
    metaNavigationItem,
    quickNavigationItems,
    reducedView
  } = t0;
  const [isNavMobileWasActive, setIsNavMobileWasActive] = useState(false);
  const {
    allCategoriesMenuVisibility: t1
  } = useSelector(selectGeneralSettings);
  const allCategoriesMenuVisibility = t1 === undefined ? CmsVisibility.INVISIBLE : t1;
  if (isNavMobileActive && !isNavMobileWasActive) {
    setIsNavMobileWasActive(true);
  }
  const showAllCategories = allCategoriesMenuVisibility === CmsVisibility.PUBLIC || allCategoriesMenuVisibility === CmsVisibility.AUTHOR && editorMode;
  let t2;
  if ($[0] !== onSidebarVisibilityChange) {
    t2 = () => onSidebarVisibilityChange(false);
    $[0] = onSidebarVisibilityChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== iconNavigationItem || $[3] !== isNavMobileActive || $[4] !== metaNavigationItem || $[5] !== navigation || $[6] !== quickNavigationItems || $[7] !== reducedView || $[8] !== t2) {
    t3 = {
      isOpen: isNavMobileActive,
      onClose: t2,
      iconNavigationEntries: iconNavigationItem,
      metaNavigationEntries: metaNavigationItem,
      quickNavigationEntries: quickNavigationItems,
      reduced: reducedView,
      navigation
    };
    $[2] = iconNavigationItem;
    $[3] = isNavMobileActive;
    $[4] = metaNavigationItem;
    $[5] = navigation;
    $[6] = quickNavigationItems;
    $[7] = reducedView;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const mobileNavigationProps = t3;
  let t4;
  if ($[10] !== editorMode || $[11] !== metadata) {
    t4 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={true} metadata={metadata} />;
    $[10] = editorMode;
    $[11] = metadata;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = `${id}-desktop`;
  let t6;
  if ($[13] !== navigation || $[14] !== reducedView || $[15] !== showAllCategories || $[16] !== t5) {
    t6 = <div className={styles["nav__desktop-wrapper"]}><DesktopNavigation id={t5} navigation={navigation} reducedView={reducedView} showAllCategories={showAllCategories} /></div>;
    $[13] = navigation;
    $[14] = reducedView;
    $[15] = showAllCategories;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== isNavMobileActive) {
    t7 = classNames(styles["nav__mobile-wrapper"], {
      [styles["nav__mobile-wrapper--active"]]: isNavMobileActive
    });
    $[18] = isNavMobileActive;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = `${id}-mobile`;
  let t9;
  if ($[20] !== mobileNavigationProps || $[21] !== t8) {
    t9 = <MobileNavigation id={t8} {...mobileNavigationProps} />;
    $[20] = mobileNavigationProps;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== editorMode || $[27] !== metadata) {
    t11 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={false} metadata={metadata} />;
    $[26] = editorMode;
    $[27] = metadata;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t4 || $[32] !== t6) {
    t12 = <nav className={styles.nav} aria-label="Main navigation" id="navigation">{t4}{t6}{t10}{t11}</nav>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t4;
    $[32] = t6;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
}